// Module
var code = "<div class=\"metric-target-and-timeleft\"><div class=\"metric-bar-target\">{{ $ctrl.metric | metric : \"targets\" : \"goal-view\" }}<div class=\"timeleft\" ng-if=\"$ctrl.metric.percentTime\">{{ $ctrl.metric | metric : \"dueDates\" }}</div></div></div>";
// Exports
module.exports = code;